import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  children: ReactNode;
  right?: boolean;
}

const Pills = ({ children, right = false }: Props) => {
  const className = classnames({
    flex: true,
    'flex-row': true,
    'flex-wrap': true,
    'my-1': true,
    'justify-end': right,
  });

  return <div className={className}>{children}</div>;
};

export default Pills;
